import(/* webpackMode: "eager" */ "/app/apps/ashtrom-energy/app/[locale]/not-found.tsx")